export default "/assets/images/google-play-store.svg?ecc77b2558874776a65399583dcf76c5";